import { Rule, RuleObject, RuleRender } from 'rc-field-form/lib/interface';
import Form from './Form';
export { Form };
export default Form;
